import {
  ReadonlyWatchable,
  Watchable,
} from '@cotera/client/v0/actions/framework';
import { WorkflowEntityNodeModel } from './workflow-entity-node-model';

export type EventTriggerNodeSnapshot = {
  readonly id: string;
  readonly name: string;
  readonly eventName: string;
  readonly enabled: boolean;
};

/**
 * Per-node view model for event triggers on the workflow canvas. State is
 * derived from the workflow graph snapshot (updated when the draft graph syncs).
 * Making the event trigger targetable is what surfaces its "Trigger now" action.
 */
export class WorkflowEventTriggerNodeModel extends WorkflowEntityNodeModel {
  readonly triggerId: string;
  readonly snapshotWatchable: ReadonlyWatchable<EventTriggerNodeSnapshot>;
  readonly eventNameWatchable: ReadonlyWatchable<string>;

  private readonly _snapshotWatchable: Watchable<EventTriggerNodeSnapshot>;

  constructor(triggerId: string, snapshot: EventTriggerNodeSnapshot) {
    super(triggerId);
    this.triggerId = triggerId;
    this._snapshotWatchable = Watchable.fromValue(snapshot);
    this.snapshotWatchable = this._snapshotWatchable;
    this.eventNameWatchable = Watchable.from(
      (get) => get(this._snapshotWatchable).eventName
    );
  }

  updateSnapshot(snapshot: EventTriggerNodeSnapshot): void {
    this._snapshotWatchable.set(snapshot);
  }

  dispose(): void {}
}
